import {translate} from 'vue-gettext';

const {gettext: $gettext} = translate;


const baseStepData = {
    done: false,
    mandatory_ok: false,
    active: false,
    suggestion: false,
}

const template = {
    ...baseStepData,
    key: 'template',
    done: true,
    mandatory_ok: true,
}

const planSettings = {
    ...baseStepData,
    name: $gettext('Plan'),
    key: 'plan_settings',
    done: true,
    mandatory_ok: true,
}

const vertical = {
    ...baseStepData,
    name: $gettext('Vertical'),
    key: 'vertical',
    done: true,
    mandatory_ok: true,
}

const eventSettings = {
    ...baseStepData,
    key: 'event_settings',
    done: true,
    mandatory_ok: true,
}

const dateAndName = {
    ...baseStepData,
    name: $gettext('Event date and name'),
    key: 'date_and_name',
}

const customizeLogoOnPhoto = {
    ...baseStepData,
    name: $gettext('Photo branding'),
    key: 'customize_logo_on_photo',
}

const bannerAdvertisement = {
    ...baseStepData,
    name: $gettext('Banner ADV + link'),
    key: 'banner_advertisement',
}

const form = {
    ...baseStepData,
    name: $gettext('Data collection'),
    key: 'form',
    done: true,
    mandatory_ok: true,
}

const customization = {
    ...baseStepData,
    name: $gettext('Customization'),
    key: 'customization',
    done: true,
    mandatory_ok: true,
}

const checkinOption = {
    ...baseStepData,
    name: $gettext('Checkin Options'),
    key: 'checkin_options',
    done: true,
    mandatory_ok: true,
}


const emailScheduler = {
    ...baseStepData,
    name: $gettext('E-Mail Scheduler'),
    key: 'email_scheduler',
    done: true,
    mandatory_ok: true,
}

const popup = {
    ...baseStepData,
    name: $gettext('PopUp'),
    key: 'popup',
    done: true,
    mandatory_ok: true,
}

const folderMapping = {
    ...baseStepData,
    name: $gettext('Folder Mapping'),
    key: 'folder_mapping',
    done: true,
    mandatory_ok: true,
}

const picaCodes = {
    ...baseStepData,
    name: $gettext('Pica Codes'),
    key: 'pica_codes',
    done: true,
    mandatory_ok: true,
}

const overview = {
    ...baseStepData,
    name: $gettext('Overview'),
    key: 'overview',
    done: true,
    mandatory_ok: true,
}

export const steps = {
    // Tab configuration
    'template': template,
    'plan_settings': planSettings,
    'vertical': vertical,
    'event_settings': eventSettings,

    // Normal steps
    'date_and_name': dateAndName,
    'customize_logo_on_photo': customizeLogoOnPhoto,
    'banner_advertisement': bannerAdvertisement,
    'customization': customization,
    'form': form,
    'checkin_options': checkinOption,
    'email_scheduler': emailScheduler,
    'popup': popup,
    'folder_mapping': folderMapping,
    'pica_codes': picaCodes,
    'overview': overview,
}